module.exports = __webpack_public_path__ + "static/media/SC-Background.651b4351.jpg";